module.exports = __webpack_public_path__ + "img/whish-white-logo_v2.808a24ab.png";